import { render } from "./PassengerDetails.vue?vue&type=template&id=74d1f542&scoped=true&lang=pug"
import script from "./PassengerDetails.vue?vue&type=script&lang=ts"
export * from "./PassengerDetails.vue?vue&type=script&lang=ts"

import "./PassengerDetails.vue?vue&type=style&index=0&id=74d1f542&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-74d1f542"

export default script